import React from 'react'
import { css } from 'aphrodite'
import { Container } from 'reactstrap'

import Sitemap from '../partials/Sitemap'

import style from './style'

const sitemapHeader = [
  { url: '/info', title: 'Info' },
  { url: '/terms', title: 'Terms of Service' }
]

export const Terms = props => {
  return [
    <Sitemap key={0} sitemap={sitemapHeader} />,
    <section key={1} className={css(style.main.section)}>
      <Container>
        <h2 className={css(style.headers.h2)}>Terms</h2>
        <p className={css(style.paragraphs.p)}>
          By accessing this web site, you are agreeing to be bound by these web
          site Terms and Conditions of Use, all applicable laws and regulations,
          and agree that you are responsible for compliance with any applicable
          local laws. If you do not agree with any of these terms, you are
          prohibited from using or accessing this site. The materials contained
          in this web site are protected by applicable copyright and trade mark
          law.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Use License</h2>

        <p className={css(style.paragraphs.p)}>
          Permission is granted to temporarily download one copy of the
          materials (information or software) on Very Poor People LLC's web site
          for personal, non-commercial transitory viewing only. This is the
          grant of a license, not a transfer of title, and under this license
          you may not: modify or copy the materials; use the materials for any
          commercial purpose, or for any public display (commercial or
          non-commercial); attempt to decompile or reverse engineer any software
          contained on Very Poor People LLC's web site; remove any copyright or
          other proprietary notations from the materials; or transfer the
          materials to another person or "mirror" the materials on any other
          server. This license shall automatically terminate if you violate any
          of these restrictions and may be terminated by Very Poor People LLC at
          any time. Upon terminating your viewing of these materials or upon the
          termination of this license, you must destroy any downloaded materials
          in your possession whether in electronic or printed format.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Disclaimer</h2>
        <p className={css(style.paragraphs.p)}>
          The materials on Very Poor People LLC's web site are provided "as is".
          Very Poor People LLC makes no warranties, expressed or implied, and
          hereby disclaims and negates all other warranties, including without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non-infringement of intellectual
          property or other violation of rights. Further, Very Poor People LLC
          does not warrant or make any representations concerning the accuracy,
          likely results, or reliability of the use of the materials on its
          Internet web site or otherwise relating to such materials or on any
          sites linked to this site.
        </p>

        <h2 className={css(style.headers.h2)}>Limitations</h2>
        <p className={css(style.paragraphs.p)}>
          In no event shall Very Poor People LLC or its suppliers be liable for
          any damages (including, without limitation, damages for loss of data
          or profit, or due to business interruption,) arising out of the use or
          inability to use the materials on Very Poor People LLC's Internet
          site, even if Very Poor People LLC or a Very Poor People LLC
          authorized representative has been notified orally or in writing of
          the possibility of such damage. Because some jurisdictions do not
          allow limitations on implied warranties, or limitations of liability
          for consequential or incidental damages, these limitations may not
          apply to you.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Revisions and Errata</h2>
        <p className={css(style.paragraphs.p)}>
          The materials appearing on Very Poor People LLC's web site could
          include technical, typographical, or photographic errors. Very Poor
          People LLC does not warrant that any of the materials on its web site
          are accurate, complete, or current. Very Poor People LLC may make
          changes to the materials contained on its web site at any time without
          notice. Very Poor People LLC does not, however, make any commitment to
          update the materials.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Links</h2>
        <p className={css(style.paragraphs.p)}>
          Very Poor People LLC has not reviewed all of the sites linked to its
          Internet web site and is not responsible for the contents of any such
          linked site. The inclusion of any link does not imply endorsement by
          Very Poor People LLC of the site. Use of any such linked web site is
          at the user's own risk.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Restrictions</h2>
        <p className={css(style.paragraphs.p)}>
          Please avoid using or encouraging the use of any of the following
          types of traffic on your advertisement URL(s) or tag(s):
        </p>
        <ul className={css(style.lists.list)}>
          <li className={css(style.lists.listItem)}>Proxies</li>
          <li className={css(style.lists.listItem)}>TOR nodes</li>
          <li className={css(style.lists.listItem)}>VPN servers</li>
          <li className={css(style.lists.listItem)}>
            Bots and exploit scanners
          </li>
          <li className={css(style.lists.listItem)}>Traffic incentivising</li>
        </ul>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>
          Site Terms of Use Modifications
        </h2>
        <p className={css(style.paragraphs.p)}>
          Very Poor People LLC may revise these terms of use for its web site at
          any time without notice. By using this web site you are agreeing to be
          bound by the then current version of these Terms and Conditions of
          Use.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Governing Law</h2>
        <p className={css(style.paragraphs.p)}>
          Any claim relating to Very Poor People LLC's web site shall be
          governed by the laws of the State of Texas without regard to its
          conflict of law provisions.
        </p>
        <p className={css(style.paragraphs.p)}>
          General Terms and Conditions applicable to Use of a Web Site.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Payment</h2>
        <p className={css(style.paragraphs.p)}>
          We make a payment after the terms of a withdrawal request have passed,
          that being NET30 by the middle of the month. All pending earnings are
          an estimate and therefore can be subject to change until made into a
          withdrawal request on the 15st of every month. We reserve the right to
          hold payment if we suspect fraudulent use of your advertisement
          without limitation (e.g. false impressions) as determined by
          VPPGamingNetwork at our sole discretion. We also retain the right to
          hold payment whereby you are in breach of our terms of service again
          using our discretion, and where you are then subsequently suspended or
          prohibited from using our services thereafter. There is a minimum
          requirement of $10.00 USD on the confirmed balance in order for us to
          be able to create the automatic withdrawal request.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Termination of Use</h2>
        <p className={css(style.paragraphs.p)}>
          You agree that we may, at our sole discretion, suspend or terminate
          your access to all or part of our website and Resources with or
          without notice and for any reason, including, without limitation,
          breach of this User Agreement. Any suspected illegal, fraudulent or
          abusive activity may be grounds for terminating your relationship and
          may be referred to appropriate law enforcement authorities. Upon
          suspension or termination, your right to use the Resources we provide
          will immediately cease, and we reserve the right to remove or delete
          any information that you may have on file with us, including any
          account or login information. Suspension (also known as an account
          access limitation, limited account) will result in all pending and
          future pending withdrawal requests being held indefinitely.
        </p>
      </Container>
    </section>
  ]
}

export default Terms



// WEBPACK FOOTER //
// ./src/components/Terms/index.js